import { IPageModel } from '@models/base-type/base-type.model';
export const ORDER_BY_ASC = 'asc';
export const ORDER_BY_DESC = 'desc';
export const DEFAULT_ORDERBY = 'CreatedDate';
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_OPTIONS = [10, 20, 50, 100];
export const PAGE_DETAIL: IPageModel = {
  page: 1,
  pageSize: 10,
  order: ORDER_BY_DESC,
  orderBy: DEFAULT_ORDERBY,
};
export const FIRST_COLUMN_ASC = [
  {
    column: 0,
    dir: 0,
  },
];

export const DT_PARAMS = {
  draw: 0,
  columns: [
    {
      data: 'string',
      name: 'string',
      searchable: true,
      orderable: true,
      search: {
        value: 'string',
        regex: true,
      },
    },
  ],
  order: [
    {
      column: 0,
      dir: 0,
    },
  ],
  start: 0,
  length: -1,
  search: {
    value: '',
    regex: true,
  },
  additionalValues: [''],
  customSearch: '',
};
